import { RouteRecordRaw } from 'vue-router';
import { TrainingMatrixEditIndividualPage } from '@/pages/training';

export const routeName = 'TreinamentosMatrizEditarCargo';

export const route: RouteRecordRaw = {
  path: 'treinamentos/matriz-treinamentos/editar/:positionId',
  name: routeName,
  component: TrainingMatrixEditIndividualPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Editar Matriz',
    permissions: [{ action: 'readMatrix', subject: 'Training' }],
  },
};
